// Import necessary MUI and React components
import React from "react";
import { Container, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
// -------------------------------------------------
// Contexts
import { useAuth } from "../contexts/auth";

// Define the PageNotFound component
const PageNotFound = () => {
  const { t } = useTranslation("pages", { keyPrefix: "PageNotFound" });
  const user = useSelector((state) => state.user.currentUser);
  const { currentAuth, verifiedAuth } = useAuth();
  return (
    <Container maxWidth="sm" style={{ textAlign: "center", marginTop: "5em" }}>
      <Typography variant="h1" gutterBottom>
        404
      </Typography>
      <Typography variant="h4" gutterBottom>
        {t("Page Not Found")}
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        {t("Sorry, the page you are looking for does not exist.")}
      </Typography>
      {!currentAuth ? (
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/sign-in"
        >
          {t("Sign In")}
        </Button>
      ) : !verifiedAuth ? (
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/ask-to-verify-email"
        >
          {t("Sign In")}
        </Button>
      ) : currentAuth &&
        verifiedAuth &&
        user &&
        user.primaryRole &&
        user.primaryRole !== "participant" ? (
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/studies"
        >
          {t("Go to Dashboard")}
        </Button>
      ) : currentAuth &&
        verifiedAuth &&
        user &&
        user.primaryRole &&
        user.primaryRole === "participant" ? (
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/tasks"
        >
          {t("Go to Tasks")}
        </Button>
      ) : (
        <Button variant="contained" color="primary" component={Link} to="/">
          {t("Go Home")}
        </Button>
      )}
    </Container>
  );
};

// Export the component
export default PageNotFound;
